import React from "react";
import { Check, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const ProblemSolution = () => {
  const { t } = useLang();
  return (
    <section data-testid="problem-solution-section" className="py-16 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="eyebrow">{t.ps.eyebrow}</div>
          <h2 className="mt-4 font-display font-light text-4xl md:text-5xl tracking-tight text-maif">
            {t.ps.title}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Problems */}
          <div
            data-testid="problems-card"
            className="rounded-2xl border border-white/[0.06] bg-[#0E0E10] p-8 md:p-10 relative overflow-hidden"
          >
            <div className="eyebrow text-maif-muted/80">— {t.ps.problems.title}</div>
            <ul className="mt-8 space-y-5">
              {t.ps.problems.items.map((it, i) => (
                <li key={i} className="flex items-start gap-3 text-maif-muted">
                  <span className="mt-1 flex h-6 w-6 items-center justify-center rounded-full bg-white/[0.04] border border-white/10">
                    <X size={14} className="text-maif-muted/70" />
                  </span>
                  <span className="text-base md:text-lg">{it}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Solutions */}
          <div
            data-testid="solutions-card"
            className="relative rounded-2xl p-8 md:p-10 overflow-hidden"
            style={{
              background:
                "linear-gradient(160deg, #1A1A1E 0%, #111114 60%)",
              border: "1px solid rgba(212,111,77,0.35)",
              boxShadow: "0 30px 80px -30px rgba(212,111,77,0.25)",
            }}
          >
            <div
              aria-hidden
              className="absolute -top-32 -right-32 w-80 h-80 rounded-full"
              style={{
                background:
                  "radial-gradient(closest-side, rgba(212,111,77,0.35), rgba(212,111,77,0) 70%)",
              }}
            />
            <div className="eyebrow text-terracotta">+ {t.ps.solutions.title}</div>
            <ul className="mt-8 space-y-5 relative">
              {t.ps.solutions.items.map((it, i) => (
                <li key={i} className="flex items-start gap-3 text-maif">
                  <span className="mt-1 flex h-6 w-6 items-center justify-center rounded-full bg-terracotta/15 border border-terracotta/40">
                    <Check size={14} className="text-terracotta" />
                  </span>
                  <span className="text-base md:text-lg">{it}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
